module.exports = __webpack_public_path__ + "assets/home-min.62ee580bb7ead6e9a7fa17789489eae2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Catlish/home-min.jpg
 ** module id = 399
 ** module chunks = 0
 **/